import { Chip, Tooltip } from '@mui/material';
import type { TenantWithStatus, TenantStatus } from '../types';

export interface TenantStatusIndicatorProps {
    tenant: TenantWithStatus;
}

const getStatusColor = (status?: TenantStatus): 'success' | 'error' | 'warning' | 'info' | 'default' => {
    switch (status) {
        case 'active':
            return 'success';
        case 'error':
            return 'error';
        case 'pending':
        case 'provisioning':
            return 'warning';
        case 'inactive':
            return 'default';
        default:
            return 'info';
    }
};

const getStatusLabel = (status?: TenantStatus): string => {
    switch (status) {
        case 'active':
            return 'Active';
        case 'inactive':
            return 'Inactive';
        case 'error':
            return 'Error';
        case 'pending':
            return 'Pending';
        case 'provisioning':
            return 'Provisioning';
        default:
            return 'Unknown';
    }
};

export function TenantStatusIndicator({ tenant }: TenantStatusIndicatorProps) {
    const status = tenant.status || 'inactive';
    const color = getStatusColor(status);
    const label = getStatusLabel(status);

    const tooltipContent = tenant.errorMessage ? `${label}: ${tenant.errorMessage}` : label;

    return (
        <Tooltip title={tooltipContent}>
            <Chip label={label} color={color} size="small" variant={status === 'active' ? 'filled' : 'outlined'} />
        </Tooltip>
    );
}
